<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">New Diploma/Licence</p>
    </header>
    <section class="modal-card-body">
      <form @submit="submit">
        <b-field label="Name" horizontal>
          <b-input v-model="name" type="text" placeholder="Give a name to your diploma" />
        </b-field>
        <div class="field is-horizontal" v-if="tempFile">
          <div class="field-label">
            <label class="label">
              File to upload:
            </label>
          </div>
          <div class="field-body">
            <b> {{tempFile.name}} </b>
          </div>
        </div>
        <b-field label="Diploma/Licence file (pdf, docx, jpeg, png, jpg)" horizontal v-else>
          <b-upload @input="(f) => tempFile = f"
            accept=".docx, .pdf, .jpeg, .jpg, .png">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Click to upload</span>
            </a>
          </b-upload>
        </b-field>
        <b-field horizontal>
          <button class="is-primary button" type="submit">Submit</button>
        </b-field>
      </form>

    </section>

  </div>
</template>

<script>

export default {
  data() {
    return {
      name: null,
      tempFile: null,
    };
  },
  computed: {
  },
  methods: {
    submit(e) {
      e.preventDefault();
      const diploma = {
        name: this.name,
        tempFile: this.tempFile,
      };
      if (Object.values(diploma).some(v => !v)) {
        this.$toast.open({
          message: 'Please fill all the options',
          type: 'is-danger',
        });
        return;
      }
      this.$emit('diplomaSaved', diploma);
      this.$parent.close();
    },
  },

};
</script>

<style lang="scss" scoped>
.rating-container {
  max-width: 400px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
